import { render, staticRenderFns } from "./sellingchart.vue?vue&type=template&id=5257339a&"
import script from "./sellingchart.vue?vue&type=script&lang=js&"
export * from "./sellingchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports